module.exports = __webpack_public_path__ + "static/media/achievement3.27b87cb0.png";